module.exports = __webpack_public_path__ + "img/khtx.ee14feac.png";